import Vue from 'vue'
import { 
    InfiniteScroll, 
    Toast 
} from 'mint-ui';

Vue.use(InfiniteScroll);

Vue.$toast = Vue.prototype.$toast = Toast;


